import { Component, OnInit, OnDestroy, Output, Input, EventEmitter } from '@angular/core';
import { UserService, OperationsService, AuthenticationService, StorageService } from '../_services/index';
import { FormArray, ReactiveFormsModule, FormsModule, FormBuilder, Validators } from '@angular/forms';
@Component({
  selector: 'app-ledger',
  templateUrl: './ledger.component.html',
  styleUrls: ['./ledger.component.css']
})
export class LedgerComponent implements OnInit {
  @Input('account_details') account_details: any;
  @Input('ledger') ledger: any;
  @Input('from_wallet') from_wallet: any = false;
  @Input('transactions') transactions: any;
  @Input('overlayOpen') overlayOpen: boolean;
  customer_name = '';
  data:any;
  filtered_data:any;
  showNoRightOverlay: boolean = false;
  @Output() dateChanged = new EventEmitter();
  ledgers: any;
  loading = false;
  currentUser: any;
  FISCAL_DATE_START = '';
  FISCAL_DATE_END = '';
  TTYPE='0';
  LENDER_ACCOUNT_ID = '';
  exportable = false;
  people_customers:any;
  PEOPLE_CUSTOMER:any;
  @Input('reloadLedger') reloadLedger = false;
  constructor(public fb: FormBuilder, public operationsService: OperationsService, public storageService: StorageService, private authService: AuthenticationService) {
    this.currentUser = this.storageService.read<any>('currentUser');

  }

  ngOnInit() { 
    this.getStatement();
    if(this.from_wallet){
      this.getListOfCustomers();
    }
  }
  grantRight(right) {
    return this.authService.userHasRights(right);
  }
  getListOfCustomers(){
    this.operationsService.getListOfCustomers(this.currentUser.token).subscribe(data => {
      this.people_customers = data.people_customer;
    });
  }
  exportRecords() {
    if (!this.grantRight('72')) {
      this.overlayOpen = false;
      this.showNoRightOverlay = true;
    } else {
      this.loading = true;
      this.exportable = false;
      // Send to the server
      this.operationsService.exportRecords(this.currentUser.token, this.account_details, this.FISCAL_DATE_START, this.FISCAL_DATE_END,this.ledgers.contra_charts).subscribe(data => {
        this.loading = false;
        if (data.status) {
          alert('Data Successfully exported. Download would start automatically.');
          window.open(data.message);
          return;
        } else {
          this.exportable = true;
          alert('Data could not be exported.');
        }
      }, () => this.exportable = true);
    }

  }
  getStatement() {
    this.loading = true;
    this.exportable = false;
    if(this.reloadLedger){
      console.log(this.account_details)
      this.operationsService.getSingleCustomerWallets(this.currentUser.token, this.account_details.PEOPLE_ID)
      .subscribe(data => {
        this.account_details = data.ledger.account_details;
        this.operationsService.getAccountStatement(this.currentUser.token, this.account_details, this.FISCAL_DATE_START, this.FISCAL_DATE_END, this.TTYPE, this.PEOPLE_CUSTOMER)
      .subscribe(data => {
        this.loading = false;
        this.ledgers = data;
        this.exportable = true;
        this.data = data.contra_charts;
        this.filtered_data = data.contra_charts;
      });

        
      }); 
    }else{

      this.operationsService.getAccountStatement(this.currentUser.token, this.account_details, this.FISCAL_DATE_START, this.FISCAL_DATE_END, this.TTYPE, this.PEOPLE_CUSTOMER)
      .subscribe(data => {
        this.loading = false;
        this.ledgers = data;
        this.exportable = true;
        this.data = data.contra_charts;
        this.filtered_data = data.contra_charts;
      });

    }
    
  }
  filterTransaction(filter: String) {
    this.filtered_data = this.data.filter(item => {
      if (item.NARRATION.toString().toLowerCase().indexOf(filter.toLowerCase()) !== -1) {
        return true;
      }
      return false;
    }
    );
  }
  filterRecords() {
    if (!this.grantRight('73')) {
      this.overlayOpen = false;
      this.showNoRightOverlay = true;
    } else {
      this.getStatement();
    }
  }
}
